export enum SystemStatus {
  ComingSoon = 0,
  Ready = 1,
}

export enum IntegrationStatus {
  MissingAccess = "missing_access",
  Connected = "connected",
  NotIntegrated = "not_integrated",
}

export interface IntegrationRow {
  id: number | null;
  integrationId: SystemId;
  integrationStatus: IntegrationStatus;
  category: SystemCategory;
  totalTasks: number;
  remainingTasks: number;
}

export interface CatalogSystem {
  id: number | null;
  integrationId: SystemId;
  category: SystemCategory;
  custom_name: string;
  status: SystemStatus;
}

export interface CategoryGroup {
  category: SystemCategory;
  systems: CatalogSystem[];
}

export interface SystemsResponse {
  integrations: IntegrationRow[];
  catalog: CategoryGroup[];
}

// Make sure these have translations under shared_ui.tasks.wizard_the_checklist.system_types.*value* in tasks.json
export enum SystemCategory {
  ACCOUNTING_SYSTEM = "accounting_system",
  PAYMENT_SYSTEMS = "payment_systems",
  POINT_OF_SALE_SYSTEM = "point_of_sale_system",
  INVENTORY_AND_ORDER_MANAGEMENT_SYSTEM = "inventory_and_order_management_system",
  BOOKING_SYSTEM = "booking_system",
  PHYSICAL_SECURITY_AND_ACCESS_SYSTEM = "physical_security_and_access_system",
  CRM = "crm",
  EMAIL_AND_COMMUNICATION_PLATFORM = "email_and_communication_platform",
  WEBSITE_AND_ECOMMERCE = "website_and_ecommerce",
  TIME_TRACKING_AND_SCHEDULING = "time_tracking_and_scheduling",
  PROJECT_AND_ISSUE_MANAGEMENT = "project_and_issue_management",
  CLOUD_STORAGE = "cloud_storage",
  MARKETING_TOOL = "marketing_tool",
  ANALYTIC_TOOL = "analytic_tool",
  CLOUD_PLATFORMS = "cloud_platform",
}

// DO NOT CHANGE values WITHOUT CHANGING organization_systems UNIQUE INDEXES
// Add square logo/icon to "shared-ui/src/assets/system-logos" folder whenever adding new systems!
export enum SystemId {
  // Custom / unspecified system.
  CUSTOM = "custom",

  // Accounting systems
  FORTNOX = "fortnox",
  VISMA = "visma",
  BOKIO = "bokio",

  // Payment systems
  STRIPE = "stripe",
  KLARNA = "klarna",
  SWISH = "swish",
  SVEA = "svea",

  // Point of Sale (POS) systems
  ZETTLE = "zettle", // formerly iZettle
  SITOO = "sitoo",
  SQUARE = "square",

  // Inventory and order management systems
  ONGOING = "ongoing",
  SHARESPINE = "sharespine",
  WOOCOMMERCE_ORDER_MANAGER = "woocommerce_order_manager",

  // Booking systems
  BOKADIREKT = "bokadirekt",
  TIMMA = "timma",
  TIMECENTER = "timecenter",

  // Security and access control systems
  VERISURE = "verisure",
  STANLEY_SECURITY = "stanley_security",
  YALE_DOORMAN = "yale_doorman",

  // CRM systems
  HUBSPOT = "hubspot",
  LIME = "lime",
  PIPEDRIVE = "pipedrive",

  // Email and communication platforms
  MICROSOFT_365 = "microsoft_365",
  GOOGLE_WORKSPACE = "google_workspace",
  SLACK = "slack",

  // Website / e-commerce platforms
  WORDPRESS = "wordpress",
  SHOPIFY = "shopify",
  WIX = "wix",

  // Time tracking and scheduling systems
  PLANDAY = "planday",
  TIMELOG = "timelog",
  BLIKK = "blikk",

  // Project and issue management systems
  TRELLO = "trello",
  ASANA = "asana",
  JIRA = "jira",

  // Cloud storage / IT infrastructure
  ONEDRIVE = "onedrive",
  GOOGLE_DRIVE = "google_drive",
  DROPBOX = "dropbox",

  // Marketing tools
  MAILCHIMP = "mailchimp",
  ACTIVECAMPAIGN = "activecampaign",
  META_BUSINESS_SUITE = "meta_business_suite",

  // Analytics tools
  GOOGLE_ANALYTICS = "google_analytics",
  MATOMO = "matomo",
  POWER_BI = "power_bi",

  // Cloud platforms
  AMAZON_WEB_SERVICES = "amazon_web_services",
  AZURE = "azure",
  GOOGLE_CLOUD_PLATFORM = "google_cloud_platform",
}

export interface System {
  id: number | null;
  system_id: SystemId;
  category: SystemCategory;
  custom_name: string;
  status: SystemStatus;
}
